import { Component, OnInit } from '@angular/core';
import { DownloadHelperService } from "src/app/api/dowload-helper.service";
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { DemandeSimulationResourceService, DocumentDTO } from '@com.sofaxis/sofaxis-fonpel-simulation-ws-ts';



@Component({
  selector: 'app-plan-action',
  templateUrl: './plan-action.component.html',
  styleUrls: ['./plan-action.component.sass']
})
export class PlanActionComponent implements OnInit {

    document: DocumentDTO;

    constructor(private downloadHelperService: DownloadHelperService,
         private demandeSimulationService: DemandeSimulationResourceService, public media: MediaObserver ) {
    }

    async ngOnInit() {
        this.demandeSimulationService.getPlanAction().subscribe( document => {
            this.document = document;
        } );
    }

    download() {
        //this.downloadHelperService.downloadFile( this.document.idDocument, this.document.libelle );
        this.demandeSimulationService.downloadDocument(this.document.idDocument).subscribe(
                result => {
                    this.downloadHelperService.saveOrOpenBlob( result, this.document.libelle);
                }
            );
        console.log("download");
    }
}
